import './BillingAddress.scss';

import React, { useEffect, useState } from 'react';

import SelectUSStates from '../../components/SelectUSStates';
import SelectZipCodes from '../../components/SelectZipCodes';
import IData from '../../shared/IData';
import IState from '../../shared/IState';

export interface IAddProps {
    setIsPaneOpen: Function;
    handleSave: Function;
    setShowCancelCreateAlert: Function;
    readOnly: boolean;
    data: IData | undefined;
}

export default function BillingAddress({
    data, readOnly, setError, setIsDirty,
    selectedUSStates, setSelectedUSStates,
    selectedZipCodes, setSelectedZipCodes }:
    {
        data: IData | undefined, readOnly: boolean, setError: Function, setIsDirty: Function,
        selectedUSStates: Array<IState>, setSelectedUSStates: Function,
        selectedZipCodes: string | undefined, setSelectedZipCodes: Function
    }) {

    const [zipCodesError, setZipCodesError] = useState<boolean>(false);

    // Aggregate any number of internal errors to a single external error which is reported to the parent.
    useEffect(() => {
        setError(zipCodesError);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zipCodesError])

    return (
        <div className={'box'}>
            <div className={'box-label'}>Billing Address</div>
            <SelectUSStates initialValue={data?.states}
                selectedUSStates={selectedUSStates}
                setSelectedUSStates={setSelectedUSStates}
                onChangeUSStates={() => setIsDirty(true)}
                readOnly={readOnly} />
            <SelectZipCodes initialValue={data?.zipCodes ? data.zipCodes.replace(/, /g, ' ') : ''}
                selectedZipCodes={selectedZipCodes}
                setSelectedZipCodes={setSelectedZipCodes}
                onChangeZipCodes={() => setIsDirty(true)}
                zipCodesError={zipCodesError}
                setZipCodesError={setZipCodesError}
                readOnly={readOnly} />
        </div>
    );
};
